var React = require('react');

function Viewmore (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M81.5.2h7.4V2H83.4V5.2h4.8V7H83.4v3.2H89V12H81.5ZM75.1,6c1.6,0,2.3-.8,2.3-2,0-1.3-.9-2-2.3-2H73V6ZM71.1.2h4.2a4.887,4.887,0,0,1,3.1,1.1,3.541,3.541,0,0,1,1,2.6V4a3.452,3.452,0,0,1-2.5,3.4L79.7,12H77.5L75,7.9H73V12H71.1V.2ZM66.8,6.1V6c0-2.4-1.3-4.2-3.2-4.2-1.8,0-3.1,1.7-3.1,4.2v.1c0,2.4,1.3,4.2,3.2,4.2,1.8-.1,3.1-1.7,3.1-4.2Zm-8.3,0V6c0-3.4,2.1-6,5.2-6,3,0,5.1,2.4,5.1,5.9V6c0,3.4-2.1,6-5.2,6-3,0-5.1-2.4-5.1-5.9ZM46.2.2h2l3.1,5.3,3-5.3h2V11.9H54.4V3.6L51.3,9,48.2,3.7v8.2H46.3V.2ZM25.1.2h2l2.3,8.4L31.7.2h1.7l2.3,8.4L38,.2h2L36.7,11.9H35L32.7,3.7l-2.3,8.2H28.6ZM16.3.2h7.4V2H18.2V5.2H23V7H18.2v3.2h5.6V12H16.3V.2ZM11.6.2h1.9V11.9H11.6ZM0,.2H2.1L5,9,7.8.2h2l-4,11.7H4Z"}));
}

Viewmore.defaultProps = {"width":"89","height":"12","viewBox":"0 0 89 12","fill":"#fff"};

module.exports = Viewmore;

Viewmore.default = Viewmore;
